import { folderSchemas } from "@redotech/redo-views-common/folders";
import { viewWithIdSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";
import { null as zNull } from "zod";
export const saveWorkOrderViewsAndFolders = {
  name: "saveWorkOrderViewsAndFolders" as const,
  input: z.object({
    folders: z.array(folderSchemas["work-orders"]),
    views: z.array(viewWithIdSchemas["work-orders"]),
  }),
  output: zNull(),
};
